export default {
  visual: {
    label: 'ORCA — персональная система рыночной информации',
    logoAlt: 'ORCA',
    eyebrow: 'РЫНОЧНЫЙ ИНТЕЛЛЕКТ',
    slogan: 'Меньше шума. Больше ясности.',
    domains: 'Крипто · Акции · Макро · Orca AI',
    nodes: { coins: 'Новости монет', alerts: 'Алерты цен', whales: 'OrcaWatch', calendar: 'Календарь', ai: 'Orca AI', portfolio: 'Портфель', social: 'X Radar', wallstreet: 'Wall Street' },
  },
  language: { label: 'Язык', ru: 'RU', en: 'EN', de: 'DE' },
  preloader: 'Анализируем рынок…',
  loading: 'Загрузка',
  checking: { title: 'Открываем ORCA', text: 'Проверяем защищённый сеанс…' },
  offline: { title: 'Нет соединения', text: 'Проверьте интернет и попробуйте ещё раз.' },
  error: {
    title: 'ORCA временно недоступна',
    email: 'Введите корректный email.',
    code: 'Введите шестизначный код.',
    codeExpired: 'Срок действия кода истёк. Запросите новый.',
    invalidCode: 'Код неверный или уже истёк.',
    provider: 'Не удалось подтвердить вход. Попробуйте ещё раз.',
    expiredFlow: 'Время входа истекло. Начните заново.',
    expiredLink: 'Ссылка недействительна или уже истекла.',
    rateLimited: 'Слишком много попыток. Попробуйте позже.',
    offline: 'Нет соединения. Проверьте интернет.',
    service: 'Сервис временно недоступен. Попробуйте позже.',
    generic: 'Что-то пошло не так. Попробуйте ещё раз.',
  },
  action: {
    google: 'Продолжить с Google',
    email: 'Продолжить с Email',
    telegram: 'Подключить через Telegram',
    continue: 'Продолжить',
    verify: 'Подтвердить',
    back: 'Назад',
    cancel: 'Отмена',
    tryAgain: 'Попробовать снова',
    checkAgain: 'Проверить снова',
    continueApp: 'Продолжить в ORCA',
    backToSignIn: 'Вернуться ко входу',
  },
  welcome: {
    eyebrow: 'WEB ORCA',
    title: 'Добро пожаловать',
    text: 'Войдите или создайте бесплатный Web-аккаунт.',
    or: 'или',
    legal: 'Продолжая, вы подтверждаете, что используете ORCA как информационный и аналитический сервис.',
  },
  session: { expired: 'Сеанс завершён. Войдите снова, чтобы продолжить.' },
  telegram: {
    offerTitle: 'Уже есть подписка ORCA в Telegram?',
    offerText: 'Подключите существующий Plus, Premium или активный Trial к Web ORCA.',
    notFoundTitle: 'Аккаунт ORCA в Telegram не найден',
    notFoundText: 'Если вы новый пользователь, зарегистрируйтесь через Email или Google.',
    paidTitle: 'Активная подписка не найдена',
    paidText: 'Подключение через Telegram доступно для Plus, Premium и активного Trial. Чтобы начать пользоваться Web ORCA, зарегистрируйтесь через Email или Google.',
    openBot: 'Открыть ORCA в Telegram',
  },
  email: {
    eyebrow: 'EMAIL',
    title: 'Войти по email',
    text: 'Мы отправим одноразовый код. Пароль не нужен.',
    requiredEyebrow: 'ЕЩЁ ОДИН ШАГ',
    requiredTitle: 'Добавьте email',
    requiredText: 'Он понадобится для входа и безопасности аккаунта. Этот шаг нельзя пропустить.',
    googleVerification: 'Подтвердите актуальный email одноразовым кодом.',
    label: 'Email',
    placeholder: 'name@example.com',
  },
  otp: {
    eyebrow: 'ПОДТВЕРЖДЕНИЕ',
    title: 'Введите код',
    text: 'Шестизначный код отправлен на {{email}}.',
    label: 'Код из письма',
    help: 'Код действует 10 минут.',
    expired: 'Код истёк. Запросите новый.',
    resend: 'Отправить код снова',
    resendIn: 'Повторно через {{seconds}} с',
    changeEmail: 'Изменить email',
  },
  link: {
    eyebrow: 'ОБЪЕДИНЕНИЕ АККАУНТОВ',
    title: 'Этот email уже используется в Web ORCA',
    text: 'У вас уже есть отдельный Web-аккаунт. Его можно объединить с подпиской ORCA в Telegram.',
    keepTitle: 'После объединения сохранятся:',
    keepPlan: 'Plus, Premium или Trial из Telegram',
    keepSettings: 'настройки и данные платного аккаунта',
    keepSchedule: 'его подписка и расписание',
    webFree: 'Отдельный Web Free аккаунт будет объединён с ним.',
    confirm: 'Объединить аккаунты',
    checking: 'Проверяем подтверждение и доступность объединения…',
    waitTitle: 'Подтвердите подключение в Telegram',
    waitText: 'Откройте ссылку в Telegram, подтвердите аккаунт и вернитесь сюда.',
    expiredTitle: 'Ссылка уже недействительна',
    expiredText: 'Запросите новую ссылку и начните подключение заново.',
  },
  blocked: {
    title: 'Сейчас аккаунты объединить нельзя',
    text: 'Доступ на обоих аккаунтах или их текущая связь не позволяют безопасно выполнить объединение. Ничего не было изменено.',
  },
  conflict: {
    title: 'Аккаунты не были объединены',
    text: 'Этот способ входа уже связан с другим аккаунтом ORCA. Выберите Email или обратитесь в поддержку.',
  },
};
